<template>
  <ul v-if="networks?.length > 1" class="t-share flex" :class="getClasses()">
    <li v-for="(network, index) in networks" :key="index">
      <UButton
        :color="'neutral'"
        :variant="variant === 'buttons' ? 'ghost' : 'solid'"
        size="md"
        type="button"
        :label="network.title"
        :icon="iconNameByKind[network.kind]"
        @click="onClick(network)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import {
  type networkType,
  type networkCopyType,
  type networkWhatsappType,
  type propsInterface,
  iconNameByKind,
} from './constants'

const props = withDefaults(defineProps<propsInterface>(), {
  variant: 'buttons',
})

const getClasses = () => {
  if (props.variant === 'buttons') {
    return 'flex-wrap gap-5 flex-col'
  } else {
    return 'flex-col gap-4 md:flex-row'
  }
}

const onClick = (network: networkType) => {
  if ('copy' === network.kind) {
    onClickCopy(network)
  } else if ('whatsapp' === network.kind) {
    onClickWhatsapp(network)
  }
}

const onClickCopy = async (networkCopy: networkCopyType) => {
  if (typeof window.ERAndroid !== 'undefined') {
    window.ERAndroid.copyToClipboard(networkCopy.url)
  } else {
    await navigator.clipboard.writeText(networkCopy.url)
  }

  window.alert(networkCopy.copiedText)
}

const onClickWhatsapp = (networkWhatsapp: networkWhatsappType) => {
  const url = encodeURIComponent(networkWhatsapp.url)

  const networkData = {
    kind: 'whatsapp',
    url: `https://api.whatsapp.com/send?text=${
      networkWhatsapp.message || ''
    } ${url}`,
    width: 550,
    height: 448,
  }
  window.open(
    networkData.url,
    'Please wait...',
    `scrollbars=1,status=0,menubar=0,personalbar=0,location=1,height=${networkData.height},width=${networkData.width},top=140,left=200`,
  )
}
</script>
